import React from 'react';
import SwitchBoxStyles from './SwitchBox.module.css';

const SwitchBox = ({ checked = false, onChange, label }) => {
	const handleChange = (event) => {
		if (onChange) {
			onChange(event.target.checked);
		}
	};

	return (
		<div className={SwitchBoxStyles.text_input} data-testid='switch-box'>
			{label && <label data-testid='switch-box-label'>{label}</label>}
			<label className={SwitchBoxStyles.switch}>
				<input
					checked={checked}
					onChange={handleChange}
					type='checkbox'
					className={SwitchBoxStyles.checkbox}
					name='active'
				/>
				<span className={[ SwitchBoxStyles.slider, SwitchBoxStyles.round ].join(' ')} />
			</label>
		</div>
	);
};

export default SwitchBox;
